import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

import { Card, IconButton, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import { BORDERS, iconControl } from "../../theme/redesign";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		alignItems: "center",
		minHeight: 64,
		minWidth: 0,
		overflow: "hidden",
		backgroundColor: theme.palette.background.paper,
		flex: "none",
		borderBottom: BORDERS.base(theme),
		boxShadow: "none",
		zIndex: 1,
		padding: "0 4px",
		borderRadius: 0,
		[theme.breakpoints.down("sm")]: {
			flexWrap: "nowrap",
			minHeight: 52,
			padding: "0 4px 0 0",
		}
	},
	backButton: {
		...iconControl(theme),
		flexShrink: 0,
		marginLeft: 4,
		[theme.breakpoints.up("md")]: {
			display: "none",
		},
	},
}));


const TicketHeader = ({ loading, children, onBack }) => {
	const classes = useStyles();
	const history = useHistory();
	const { setCurrentTicket } = useContext(TicketsContext);
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card square className={classes.ticketHeader}>
					{isMobile && (
						<Tooltip title="Volver">
							<IconButton
								className={classes.backButton}
								onClick={() => {
									if (onBack) {
										onBack();
										return;
									}
									setCurrentTicket({ id: null, code: null });
									if (history.length > 1) history.goBack();
									else history.push("/tickets");
								}}
								aria-label="Volver"
							>
								<ArrowBackIos fontSize="small" />
							</IconButton>
						</Tooltip>
					)}
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
